import { useHotel } from './use-hotel.hook';

export const useHotelAddress = (hotelReferenceId: string | undefined) => {
  const hotel = useHotel(hotelReferenceId);
  return hotel?.location.address;
};

export const useHotelAddressAsString = (
  hotelReferenceId: string | undefined
) => {
  const address = useHotelAddress(hotelReferenceId);

  if (!address) return undefined;

  const { lines, city, postcode } = address;
  return [...(lines || []), city, postcode].join(', ');
};
